import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const VendorCtaSection = () => {
  const navigate = useNavigate();

  const quickLinks = [
    { icon: 'LayoutDashboard', label: 'Vendor Dashboard', path: '/vendor-hub-dashboard', desc: 'Manage your pipeline' },
    { icon: 'BarChart3',       label: 'View Analytics',   path: '/vendor-analytics-dashboard', desc: 'Track your performance' },
    { icon: 'TrendingUp',      label: 'Manage Ads',       path: '/vendor-analytics-advertising', desc: 'Boost your visibility' },
  ];

  return (
    <section className="py-20 bg-background">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-16">
          {quickLinks?.map((link, i) => (
            <button
              key={i}
              onClick={() => navigate(link?.path)}
              className="group flex items-center gap-4 bg-card border border-border rounded-2xl p-5 hover:border-primary/40 hover:shadow-md transition-all duration-200 text-left"
            >
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors duration-200">
                <Icon name={link?.icon} size={22} color="#F06F6B" />
              </div>
              <div>
                <div className="font-semibold text-foreground text-sm">{link?.label}</div>
                <div className="text-text-secondary text-xs mt-0.5">{link?.desc}</div>
              </div>
              <Icon name="ArrowRight" size={16} color="#6B7280" className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </button>
          ))}
        </div>

        <div className="relative overflow-hidden rounded-3xl p-10 md:p-14 text-center" style={{ background: 'linear-gradient(to bottom right, #F58A54, #F06F6B, #E0528A)' }}>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/5 blur-2xl" />
            <div className="absolute -bottom-16 -left-16 w-64 h-64 rounded-full bg-white/5 blur-2xl" />
          </div>
          <div className="relative">
            <div className="w-16 h-16 rounded-2xl bg-white/15 flex items-center justify-center mx-auto mb-6">
              <Icon name="Zap" size={28} color="white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Ready to start winning bids?
            </h2>
            <p className="text-white/75 text-lg max-w-xl mx-auto mb-8">
              Join Stackd's vendor network and connect with qualified buyers actively looking for your services.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => navigate('/vendor-hub-dashboard')}
                className="px-8 py-3.5 bg-white text-primary font-semibold rounded-xl hover:bg-white/90 transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5"
              >
                Go to My Dashboard
              </button>
              <button
                onClick={() => navigate('/vendor-quote-request-landing')}
                className="px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/30 text-white font-semibold rounded-xl hover:bg-white/20 transition-all duration-200"
              >
                Join as a Vendor
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorCtaSection;
